import Vue from 'vue';

export default class ValidateException {
  message: any;
  type: any;
  constructor(type: any, message: any) {
    this.type = type;
    this.message = message;
  }
  static alertError(error: any, info: any) {
    console.error('error in', info);
    Vue.prototype.$dialog.notify.error(error.message);
  }
  static alertWarning(error: any, info: any) {
    console.warn('warning in', info);
    Vue.prototype.$dialog.notify.warning(error.message);
  }
}
